// @flow
import { useField } from 'react-final-form';
/**
 * Simple wrapper to be able to specify the type of the value from useField
 * @warning It only subscribes to 'value'
 * @example ```
   const mailboxType = useFieldWithType<string>(MAILBOX_TYPE_INPUT_NAME);
   ```
 */
export const useFieldWithTypeValue = <T>(name: string): T => {
  const {
    input: { value },
    // $FlowFixMe[prop-missing]
  } = useField(name, { subscriptions: { value: true } });
  return value;
};
